import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-investments-period',
	templateUrl: './investments-period.component.html',
	styleUrls: ['./investments-period.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentsPeriodComponent implements OnInit {

	public submited = false;

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-period/investments-period.component.ts